module.exports = __webpack_public_path__ + "static/media/zlto_logo_white.d728ec00.svg";